import { IconProps } from '../icon';

export function UserCheckInterfaceSymbolIcon(props: IconProps) {
  return (
    <svg
      enableBackground="new 0 0 43.028 43.028"
      height="43.028"
      viewBox="0 0 43.028 43.028"
      width="43.028"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m39.561 33.973-.145.172c-4.774 5.729-11.133 8.884-17.902 8.884-6.77 0-13.128-3.154-17.903-8.884l-.144-.172.034-.225c.922-6.014 4.064-10.844 8.847-13.605l.34-.196.271.284c2.259 2.369 5.297 3.674 8.554 3.674s6.295-1.306 8.554-3.674l.271-.284.34.196c4.783 2.762 7.925 7.592 8.848 13.605zm-18.047-12.485c5.924 0 10.744-4.82 10.744-10.744s-4.82-10.744-10.744-10.744-10.744 4.82-10.744 10.744 4.82 10.744 10.744 10.744zm7.463 14.366 5.505-5.506c.616-.615.616-1.615 0-2.229-.616-.617-1.616-.617-2.231 0l-4.389 4.39-2.752-2.752c-.617-.617-1.615-.617-2.232 0-.614.614-.614 1.614 0 2.231l3.869 3.866c.309.31.711.463 1.115.463s.806-.157 1.115-.463z" />
    </svg>
  );
}

export default UserCheckInterfaceSymbolIcon;
